import {
    SHOW_ORDER_FILTER,
    CLOSE_ORDER_FILTER,
    TOGGLE_ORDER_FILTERS,
    CATEGORY_SELECTED,
    QUICK_FILTER_SELECTED,
    GET_DISTRICT_SUCCESS,
    GET_TERRITORY_SUCCESS,
    GET_ACCOUNTS_SUCCESS,
    SET_APPLIED_VIEW_ORDER_FILTER,
    SET_FILTER_TYPE,
    SET_CATEGORY_FILTER,
    RESET_APPLIED_ORDER_FILTER,
    OPEN_POPOVER,
    RESET_ACCOUNTS,
    RESET_TERRITORY,
    SET_SHOW_EXPANDED_VIEW,
    SET_SHOW_EXPANDED_FILTER,
    SET_SHOW_EXPANDED_SEARCH_PANEL,
    GET_DISTRICT,
    ORDER_LIST_FILTER_RESET,
    SET_NOTIFICATION_FAILURE_LIST,
    SET_NOTIFICATION_FAILURE_RESPONSE,
    RESTORE_ORDER_FILTER_SNAPSHOT,
} from '../actions/index';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    loading: false,
    categoryId: 1,
    quickFilterName: '',
    districts: [],
    districtSuccess: true,
    territories: [],
    territorySuccess: true,
    isOrderListingPage: false,
    accounts: [],
    accountSuccess: true,
    appliedQuickFilter: {},
    appliedCategory: {},
    appliedView: {
        appliedDistrict: {},
        appliedTerritory: {},
        appliedAccount: {},
        appliedOrderCondition: {},
    },
    appliedFilter: {
        appliedOrderType: [],
        appliedOrderStatus: [],
        appliedNotificationFailure: []
    },
    notificationFailureList:[{ description: 'Notification Failure', isChecked: false, statusCode: 'NOTIFICATION_FAILURE' }],
    isQuickFilter: false,
    isFromOrderSummary:false,
    notificationStatus:'',
    categoryFilters: [],
    isFilterType: 'initial', //isFilter = initial, date, category, quickFilter, delete, AppliedView,ResetView, ResetFilter,pagination, pageSort, AppliedFilter
    isFilterPopoverOpen: {
        isSet: false,
        isShowView: true,
        isShowFilter: false,
    },
    showExpandedView: {
        districtView: true,
        territoryView: false,
        accountView: false,
        orderConditionView: false,
    },
    showExpandedFilter: {
        OrderStatusView: true,
        orderTypeFilter: true,
        notificationFailure: true,
    },
    showExpandedSearchPanel: {
        surgeryDetails: true,
        orderNumbers: true,
        shipping: true,
    },
};

const OrdersFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_ORDER_FILTER:
            return { ...state, showOrderFilter: true };
        case CLOSE_ORDER_FILTER:
            return { ...state, showOrderFilter: false, viewOrderListTab: true };
        case TOGGLE_ORDER_FILTERS:
            return {
                ...state,
                viewOrderListTab: !state.viewOrderListTab,
            };
        case CATEGORY_SELECTED:
            return {
                ...state,
                categoryId: action.payload.id,
                appliedCategory: { ...action.payload },
            };
        case QUICK_FILTER_SELECTED:
            return {
                ...state,
                quickFilterName: action.payload.label,
                appliedQuickFilter: { ...action.payload },
            };
        case GET_DISTRICT:
            return {
                ...state,
                isOrderListingPage: action.payload,
            };
        case GET_DISTRICT_SUCCESS:
            return {
                ...state,
                ...action.data,
                districtSuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case GET_TERRITORY_SUCCESS:
            return {
                ...state,
                ...action.data,
                territorySuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case GET_ACCOUNTS_SUCCESS:
            return {
                ...state,
                ...action.data,
                accountSuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case RESET_TERRITORY:
            return {
                ...state,
                territories: [],
                territorySuccess: true,
            };
        case RESET_ACCOUNTS:
            return {
                ...state,
                accounts: [],
                accountSuccess: true,
            };
        case SET_APPLIED_VIEW_ORDER_FILTER:
            return {
                ...state,
                appliedView: { ...action.payload.appliedView },
                appliedFilter: { ...action.payload.appliedFilter },
            };
        case SET_FILTER_TYPE:
            return {
                ...state,
                isFilterType: action.payload,
            };
            case SET_NOTIFICATION_FAILURE_LIST:
                const item=action?.payload?.[0]??{};
            return {
                ...state,
                notificationFailureList: [{isChecked: item?.isChecked??false,description:'Notification Failure',statusCode:'NOTIFICATION_FAILURE'}],
            };
            case SET_NOTIFICATION_FAILURE_RESPONSE:
            return{
                 ...state,
                notificationStatus: action?.data?.statusCode,
                isFromOrderSummary: action?.data?.myCaseRef,
            };
        case SET_CATEGORY_FILTER:
            return {
                ...state,
                ...action.payload,
            };
        case RESET_APPLIED_ORDER_FILTER:
            return {
                ...state,
                appliedFilter: { ...action.payload.appliedFilter },
               
            };
        case OPEN_POPOVER:
            return {
                ...state,
                isFilterPopoverOpen: { ...action.payload },
            };
        case SET_SHOW_EXPANDED_VIEW:
            return {
                ...state,
                showExpandedView: { ...action.payload },
            };
        case SET_SHOW_EXPANDED_FILTER:
            return {
                ...state,
                showExpandedFilter: { ...action.payload },
            };
        case SET_SHOW_EXPANDED_SEARCH_PANEL:
            return {
                ...state,
                showExpandedSearchPanel: { ...action.payload },
            };
        case ORDER_LIST_FILTER_RESET:
            return {
                ...state,
                appliedCategory: {},
                appliedFilter: { ...initialState.appliedFilter },
                appliedQuickFilter: {},
                appliedView: { ...initialState.appliedView },
                showExpandedView: { ...initialState.showExpandedView },
                showExpandedFilter: { ...initialState.showExpandedFilter },
                showExpandedSearchPanel: {
                    ...initialState.showExpandedSearchPanel,
                },
            };
        case RESTORE_ORDER_FILTER_SNAPSHOT:
            return {
                ...state,
                appliedCategory: action.payload.appliedCategory || {},
                appliedFilter: action.payload.appliedFilter || { ...initialState.appliedFilter },
                appliedQuickFilter: action.payload.appliedQuickFilter || {},
                appliedView: action.payload.appliedView || { ...initialState.appliedView },
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'orderFilterKey',
        storage: storage,
        whitelist: [
            'appliedCategory',
            'appliedFilter',
            'appliedQuickFilter',
            'appliedView',
            'showExpandedView',
            'showExpandedFilter',
            'showExpandedSearchPanel',
            'notificationFailureList',
            'categoryFilters',
        ],
    },
    OrdersFilterReducer
);
